export default {
  black: 'text-lighten-3 grey-text',
  white: 'black-text',
  blue: 'text-lighten-4 grey-text',
  green: 'text-lighten-4 grey-text',
  grey: 'white-text',
  yellow: 'text-darken-1 grey-text',
  purple: 'text-lighten-2 grey-text',
  red: 'text-lighten-4 grey-text'
};



// WEBPACK FOOTER //
// ./src/shared/colors.tsx